import type { ActivityHeaderAction } from './types';

/**
 * Реестр действий меню «Создать ▾» в шапке Activity-чата.
 * Upsert по `id` — безопасно для dev/HMR. Порядок = порядок регистрации.
 */
class ActivityHeaderActionRegistry {
  private static instance: ActivityHeaderActionRegistry | null = null;

  private readonly actionsById = new Map<string, ActivityHeaderAction>();

  static getInstance(): ActivityHeaderActionRegistry {
    if (!ActivityHeaderActionRegistry.instance) {
      ActivityHeaderActionRegistry.instance = new ActivityHeaderActionRegistry();
    }
    return ActivityHeaderActionRegistry.instance;
  }

  register(action: ActivityHeaderAction): void {
    this.actionsById.set(action.id, action);
  }

  getAvailable(entityType: string): ActivityHeaderAction[] {
    return Array.from(this.actionsById.values()).filter(action =>
      action.isAvailable(entityType)
    );
  }
}

export const activityHeaderActionRegistry = ActivityHeaderActionRegistry.getInstance();

/**
 * Регистрирует действие для меню «Создать ▾» (upsert по `id`).
 * Вызывается из bootstrap модуля-владельца действия.
 */
export function registerActivityHeaderAction(action: ActivityHeaderAction): ActivityHeaderAction {
  activityHeaderActionRegistry.register(action);
  return action;
}

/** Действия, доступные для треда с данным `entity_type` (может быть пусто). */
export function getActivityHeaderActions(entityType: string): ActivityHeaderAction[] {
  return activityHeaderActionRegistry.getAvailable(entityType);
}
